module.exports = __webpack_public_path__ + "static/teddymain-b3be27d10a3d933f87c0f9d80130376f.png";